<div
  *ngIf="question && showQuestion"
  [hidden]="question.hidden"
  [class]="'form-typography open-raptor-payment raptor-question-key-' + question.key"
>
  <div *ngIf="question.info && question.info.settings && question.info.settings.align === 'top'" class="margin-bottom-xmedium">
    <open-raptor-info [info]="question.info" [form]="form"></open-raptor-info>
  </div>

  <div class="flex flex-content-center">
    <label *ngIf="question.prompt" [attr.for]="question.key" class="raptor-question-label">
      <span>{{ question.prompt }}</span>
    </label>
    <open-tooltip *ngIf="question.help && (!question.help.type || question.help.type === 'tooltip')" [tooltipContent]="question.help.content"></open-tooltip>
  </div>
  <p
    *ngIf="question.subtext"
    class="margin-bottom-xmedium"
    [innerHTML]="question.subtext"
    [ngClass]="{
      'text-left': !question.settings || !question.settings.align || question.settings.align === 'left',
      'text-center': question.settings.align === 'center',
      'text-right': question.settings.align === 'right'
    }"
  ></p>

  <div *ngIf="question.settings.payment_options && question.settings.payment_options.length > 1" class="open-tile-radio">
    <h2 class="margin-bottom-small">Select your payment option</h2>
    <mat-radio-group aria-label="Select an option" [class]="'tile-length-' + question.settings.payment_options.length" [(ngModel)]="paymentForm" (change)="optionChange($event)">
        <div class="grid open-tile-radio-container">
          <div *ngFor="let option of paymentOptions;" class="radio-wrapper cell cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6 margin-right-none">
            <mat-radio-button [value]="option" class="large open-tile-radio-button">
            <open-svg-icon name="{{ option.icon }}" class="small radio-wrapper-icon flex flex-items-center flex-justify-center"></open-svg-icon>
            <div class="flex-content-center margin-right-xsmall margin-left-xxsmall">
                <span class="strong" [innerHTML]="option.label"></span>
            </div>
          </mat-radio-button>
        </div>
      </div>
    </mat-radio-group>
  </div>

  <div class="raptor-question-field" *ngIf="paymentForm">
    <ng-container [ngSwitch]="paymentForm.service">

      <ng-container *ngSwitchCase="'stripe'">
        <open-raptor-stripe-form [question]="question" [option]="paymentForm" [form]="form"></open-raptor-stripe-form>
      </ng-container>

      <ng-container *ngSwitchCase="'gocardless'">
        <open-raptor-gocardless-form [question]="question" [option]="paymentForm" [form]="form"></open-raptor-gocardless-form>
      </ng-container>
      
    </ng-container>
  </div>

  <!-- Question disclaimer -->
  <p *ngIf="question.disclaimer && question.disclaimer.content" class="text-small" [innerHTML]="question.disclaimer.content"></p>

  <div *ngIf="question.info && (!question.info.settings || question.info.settings.align !== 'top')">
    <open-raptor-info [info]="question.info" [form]="form"></open-raptor-info>
  </div>
</div>

